module.exports = __webpack_public_path__ + "img/yw.f6672068.png";